export default __webpack_public_path__ + "static/media/SK.4cacc570.svg";